import { defaultHeatmapImage } from 'lib/helpers';
import get from 'lodash.get';
import { SplitTestInterface } from 'pages/users/split-tests/split-tests.interface';

export function getCoverPhoto(splitTest: SplitTestInterface): string {
  const input = get(splitTest, 'inputFile[0][1].image', defaultHeatmapImage);
  return get(splitTest, 'outputFile[0][1].image', input);
}
